import React, { useContext } from 'react'
import { LocaleContext } from '../../contexts/locale'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'

import './styles.scss'

export const Rules = () => {
  const locale = useContext(LocaleContext)
  const RuleMDX = require('./rules.' + locale + '.mdx').default

  return (
    <RuleMDX
      components={{
          ul: props => (
            <div className='ui relaxed inverted icon list playRules' {...props} />
          ),
          li: props => <div className='item'>
            <i className='right triangle icon' />
            <div className='content' {...props} />
          </div>,
          h3: props => <h3 className='ui small header inverted centered playRules' {...props} />,
      }}
    />
  )
}
